<template>
  <v-flex lg8 sm10 xs12>
    <v-layout justify-end>
      <v-btn dark small color="error" @click="setDeletionDialog(true)">
        Excluir Capítulo
        <v-icon small>delete</v-icon>
      </v-btn>
    </v-layout>
    <reversible-text-field
      class="title mb-2"
      :text="chapter ? (chapter.title || '') : ''"
      label="Título"
      textClass="headline"
      @didTapSave="updateTitle"
    />
    <reversible-text-field
      class="description"
      :text="chapter ? (chapter.description || '') : ''"
      label="Descrição"
      multiline
      @didTapSave="updateDescription"
    />
    <ReversibleIconsSelect
      class="icon"
      v-if="chapterWasDownloaded"
      :chapter="chapter || {icon: 'insert_drive_file'}"
      @didTapSave="updateIcon"
      @iconWasChanged="chapter.icon=$event"
    />
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ message }}
      <v-btn text @click="closeMessage">Fechar</v-btn>
    </v-snackbar>

    <default-dialog 
      :value="deletionDialog" 
      :title="'Exclusão'"
      color="error"
      @input="setDeletionDialog(false)"
    >
      <p class="pt-2">Você tem certeza que deseja excluir o capítulo? Os conteúdos cadastrados não serão mais acessíveis.</p>
      <template slot="actions">
        <v-spacer />
        <v-btn text dark color="disabled" @click="setDeletionDialog(false)">Cancelar</v-btn>
        <v-btn dark color="error" @click="deleteChapter">Excluir</v-btn>
      </template>
    </default-dialog>
  </v-flex>
</template>

<script>
import DefaultDialog from "@/components/dialogs/Default";
import {
  updateChapter,
  deleteChapter
} from "@/firebase/api/chapter";
import ReversibleTextField from "@/components/ReversibleTextField";
import ReversibleIconsSelect from "@/components/ReversibleIconsSelect";

export default {
  components: { ReversibleTextField, ReversibleIconsSelect, DefaultDialog },
  props: {
    chapter: Object
  },

  data: () => ({
    snackbar: false,
    deletionDialog: false,
    snackbarColor: "",
    message: "",
    chapters: [],
    titleUpdateMessages: {
      sucess: "O título foi atualizado.",
      error: "Erro na atualização do título na base de dados.",
    },
    descriptionUpdateMessages: {
      sucess: "A descrição foi atualizada.",
      error: "Erro na atualização da descrição na base de dados."
    },
    iconUpdateMessages: {
      sucess: "O ícone foi atualizado.",
      error: "Erro na atualização do ícone na base de dados."
    },
  }),

  computed: {
    chapterWasDownloaded() {
      return Object.keys(this.chapter || {}).length > 0;
    },
    chapterID() {
      return this.$route.params.chapterID;
    }
  },

  methods: {
    showMessage(message, snackbarColor) {
      this.message = message;
      this.snackbarColor = snackbarColor;
      this.snackbar = true;
    },
    showUpdateMessage(fieldUpdated) {
      const updateMessages = this[`${fieldUpdated}UpdateMessages`];
      const message = fieldUpdated ? updateMessages.sucess : updateMessages.error;
      const snackbarColor = fieldUpdated ? "blue darken-3" : "error";
      this.showMessage(message, snackbarColor);
    },
    showDeletionErrorMessage() {
      const message = `Erro na exclusão do capítulo "${this.chapter.title}"`;
      const snackbarColor = "error";
      this.showMessage(message, snackbarColor);
    },
    evaluateTitle(title) {
      const filter = chapter => chapter.title === title;
      const chaptersWithSameTitle = this.chapters.filter(filter);
      return chaptersWithSameTitle.length === 0;
    },
    chapterAlreadyExistsError(title) {
      const message = `O capítulo "${title}" já existe.`;
      const snackbarColor = "error";
      this.showMessage(message, snackbarColor);
    },
    backToIntroduction() {
      this.$router.push('/');
    },
    updateChapter(chapterID, attributeObj, evaluateTitle) {
      if (!evaluateTitle || this.evaluateTitle(attributeObj.title)) {
        updateChapter(chapterID, attributeObj).then(this.showUpdateMessage);
      } else {
        this.chapterAlreadyExistsError(attributeObj.title);
      }
    },

    closeMessage() {
      this.snackbar = false;
    },

    setDeletionDialog(state) {
      this.deletionDialog = state
    },

    updateTitle(title) {
      title = title.trim()
      this.updateChapter(this.chapterID, { title }, true);
    },

    updateDescription(description) {
      description = description.trim()
      this.updateChapter(this.chapterID, { description });
    },

    updateIcon(icon) {
      this.updateChapter(this.chapterID, { icon });
    },
    deleteChapter(){
      this.setDeletionDialog(false)
      deleteChapter(this.chapterID).then(sucess => {
        if(sucess)
          this.backToIntroduction();
        else
          this.showDeletionErrorMessage();
      });
    },

  }
};
</script>